export const defaultLang = 'en';

export const calcTotal = (arr) => {
    let total = 0;
    for(let i = 0; i < arr.length; i++) {
        total += arr[i].totalPrice;
    }
    return total;
}